export default __webpack_public_path__ + "static/media/img11.49ae22ae.svg";